'use strict';

var _ = require('lodash');
var LastAdjustmentTooltipFactory = function LastAdjustmentTooltipFactory($filter, UserSecureService) {
  var HIDE_DELAY = 700;
  var SHOW_DELAY = 100;
  var rmMomentFormat = $filter('rmMomentFormat');
  var columnToLatestChanges = {
    userAuthLink: 'userLinkType',
    userMinAuthorization: 'userHardOverrideMinValue',
    userMaxAuthorization: 'userHardOverrideMaxValue'
  };
  function LastAdjustmentTooltip() {}
  LastAdjustmentTooltip.constructor = LastAdjustmentTooltip;
  function getAppliedByWithLinkToRule(ruleName, technicalId) {
    return '<a ng-controller="LastAdjustmentTooltipController" ng-click="navigateToRules(\'' + technicalId + '\')">' + '<span class="last-adjustment-rule-link">' + ruleName + '</span>' + '</a>';
  }
  function invalidEntry(latestChanges, column) {
    if (!latestChanges) {
      return true;
    }
    var latestChangesDetails = latestChanges[column] || latestChanges[columnToLatestChanges[column]];
    return !latestChangesDetails || !latestChangesDetails.appliedBy && !latestChangesDetails.ruleId;
  }
  function getHtmlContent(cellData, wholeGridData) {
    var column = cellData.column;
    var latestChanges = wholeGridData[cellData.row].latestChanges;
    var userData;
    if (invalidEntry(latestChanges, column)) {
      return null;
    }
    var lastOptChangeDate = rmMomentFormat(wholeGridData[cellData.row].lastProcessedDateMoment, 'DATE_TIME_USER_SETTINGS');
    var tooltipData = {
      lastOptChangeDate: lastOptChangeDate
    };
    var latestChangesDetails = latestChanges[column] || latestChanges[columnToLatestChanges[column]];
    if (latestChangesDetails.ruleId) {
      tooltipData.appliedBy = getAppliedByWithLinkToRule(latestChangesDetails.appliedBy, latestChangesDetails.ruleId);
    } else {
      userData = UserSecureService.getUserDisplayNameFromId(latestChangesDetails.appliedBy);
      tooltipData.appliedBy = userData ? userData.getDisplayName() : latestChangesDetails.appliedBy;
    }
    var tooltipContent = _.template(require('../templates/last-adjustment-tooltip.html'));
    return tooltipContent(tooltipData);
  }
  LastAdjustmentTooltip.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      var htmlContent = getHtmlContent(cellData, wholeGridData);
      if (!htmlContent) {
        return;
      }
      return {
        htmlContent: htmlContent,
        hideDelay: HIDE_DELAY,
        showDelay: SHOW_DELAY,
        placement: 'top-right'
      };
    };
  };
  return LastAdjustmentTooltip;
};
LastAdjustmentTooltipFactory.$inject = ['$filter', 'UserSecureService'];
module.exports = LastAdjustmentTooltipFactory;